<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section mb-2">
                <div class="pl-2">
                    <span>
                        <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})"><i class="fas fa-long-arrow-alt-left"></i> <b>Home</b></a>
                    </span>
                </div>
            </div>
            <div class="profile-section" :style="{ 'padding': 'unset'}">
                <div class="form-row align-items-center pt-2 m-1">
                    <!-- Search Input -->
                    <div class="col-12 col-md-6 mb-2">
                        <div class="">
                            <input type="text" class="form-control" placeholder="Enter Url" v-model="url" />
                        </div>
                    </div>

                    <!-- Filter Dropdown -->
                    <div class="col-12 col-md-4 mb-2">
                        <select class="form-control" aria-label="Status" v-model="isBlocked"> 
                            <option value="">Status</option>
                            <option value="true">Block</option>
                            <option value="false">Unblock</option>
                        </select>
                    </div>

                    <!-- Created Button -->
                    <div class="col-12 col-md-2 mb-2">
                        <button  class="btn btn-success btn-block" @click="addUrl()" :disabled="isDisabled">
                            Add<span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
                        </button>
                    </div>

                </div>
            </div>
            <div class="profile-section">
                <div class="m-2" :style="{ 'padding-right': '2px'}">
                    <div class="input-group border">
                        <div class="input-group-prepend">
                            <div class="input-group-text" :style="{ 'background-color': 'white', 'border-left': 'unset','border-top': 'unset', 'border-bottom': 'unset' }" id="btnGroupAddon">
                                <a class="text-black" href="javascript:void(0)" @click="previousDate()">
                                    <ArrowLeftIcon /> 

                                </a>
                            </div>
                        </div>
                        <div class="form-control text-center" :style="{ 'border': 'unset', 'font-weight': 'bold' }">{{ this.formattedDate }}</div>
                        <div class="input-group-prepend">
                            <div class="input-group-text" :style="{ 'background-color': 'white', 'border-left': 'unset','border-top': 'unset', 'border-bottom': 'unset' }" id="btnGroupAddon">
                                <a class="text-black" href="javascript:void(0)" @click="nextDate()">
                                    <ArrowRightIcon /> 
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-row align-items-center pt-2">

                        <!-- Search Input -->
                        <div class="col-12 col-md-6 mb-2">
                            <div class="input-group has-search">
                                <span class="fa fa-search form-control-feedback"></span>
                                <input type="text" class="form-control" placeholder="Search by urls" v-model="urlText" />
                            </div>
                        </div>

                        <!-- Filter Dropdown -->
                        <div class="col-12 col-md-4 mb-2">
                            <select class="form-control" aria-label="Filter by Status" v-model="filterByStatus"> 
                                <option value="">Filter By Status</option>
                                <option value="block">Block Urls</option>
                                <option value="unblock">Unblock Urls</option>
                            </select>
                        </div>

                        <!-- Search Button -->
                        <div class="col-12 col-md-2 mb-2">
                            <button  class="btn btn-primary btn-block" @click="getBrowserLogs()" :disabled="isDisabled">
                                Search<span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
                            </button>
                        </div>

                    </div>
                </div>
                <div class="d-flex justify-content-end m-2">
                    <button v-if="filterByStatus == 'block' && browserLogsData.length > 0"  class="btn btn-warning mr-2 float-right" @click="unBlockAll()" :disabled="isDisabled">
                        Unblock All<span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
                    </button>
                </div>
                
                <div class="history-item m-2" v-for="log in browserLogsData" :key="log._id">
                    <div>
                        <a :href="addHttp(log.url)" target="_blank">{{ log.url }}</a><br>
                        <small>
                            <b>Updated On :</b>{{ formatDate(log.updated_at) }},
                            <b>Created On :</b>{{ formatDate(log.created_at) }}
                        </small>
                    </div>
                    <a href="javascript:void(0)" v-if="log.isBlocked == true" @click="updateLogUrlStatus(log._id, false)"><i class="fas fa-lock lock-icon text-danger"></i></a>
                    <a href="javascript:void(0)" v-else @click="updateLogUrlStatus(log._id, true)"><i class="fas fa-unlock lock-icon text-primary"></i></a>
                </div>
                <p v-if="browserLogsData.length == 0" class="pl-2">No data found.</p>
            </div>
            <KidFooter />
        </div>
    </div>
</template>
<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'

let options = { weekday: 'short', month: 'long', day: 'numeric' };

export default {
  name: 'Browser Logs',
  components: {
    KidHeader,
    KidFooter,
    ArrowLeftIcon,
    ArrowRightIcon,
  },
  data() {
    return {
        isDisabled: false,
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        formattedDate: new Date().toLocaleDateString("en-US", options),
        currentDate: new Date(),
        filterType: "Day",
        browserLogsData: [],
        urlText: "",
        filterByStatus: "",
        url: "",
        isBlocked: ""
    }
  },
  methods: {
    previousDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() - (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", options);
        } else {
            this.formattedDate = "Previous Week"
            this.weekType = "Previous";
        }
        this.getBrowserLogs()
    },
    nextDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() + (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", options)
        } else {
            this.formattedDate = "This Week",
            this.weekType = "Current";    
        }
        this.getBrowserLogs()
    },
    async getBrowserLogs() {
        this.isDisabled = true;
        let data = { currentDate: this.currentDate, serialNumber: this.serialNumber, urlText: this.urlText, filterByStatus: this.filterByStatus };
        await KidsService.getBrowserLogs(data)
        .then((response) => {
            this.isDisabled = false;
          this.browserLogsData = response.data.data;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async unBlockAll() {
        this.isDisabled = true;
        let data = { serialNumber: this.serialNumber };
        await KidsService.unBlockAll(data)
        .then((response) => {
            this.isDisabled = false;
            this.getBrowserLogs();
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateLogUrlStatus(id, isBlocked) {
        let data = { id: id, isBlocked: isBlocked, serialNumber: this.serialNumber };
        await KidsService.updateLogUrlStatus(data)
        .then((response) => {
          this.getBrowserLogs();
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    formatDate(dateStr) {
        const date = new Date(dateStr);
        return date.toLocaleString('en-US', {
            dateStyle: 'medium',
            timeStyle: 'short'
        });
    },
    async addUrl() {
        this.isDisabled = true;
        let data = { serialNumber: this.serialNumber, url: this.url, isBlocked: this.isBlocked };
        await KidsService.createBrowserLog(data)
        .then((response) => {
            this.isDisabled = false;
            this.getBrowserLogs();
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    addHttp(url) {
        if (!/^https?:\/\//i.test(url)) {
        return 'http://' + url;
        }
        return url;
    }
  },
  beforeMount() {
    this.getBrowserLogs();
  },
}
</script>